import axiosInstance from "../../axios/axiosInstance";
import {
  BILLING_BALANCE,
  BILLING_CANCEL_SUBSCRIPTION,
  BILLING_CLAIM_TRIAL,
  BILLING_PLANS,
  BILLING_SUBSCRIBE,
  BILLING_SUBSCRIPTION_VERIFY,
  BILLING_TOPUP_CREATE_ORDER,
  BILLING_TOPUP_PACKS,
  BILLING_TOPUP_VERIFY,
  BILLING_TRANSACTIONS,
} from "../../constants";

export const getBillingPlans = () => axiosInstance.get(BILLING_PLANS);

export const getTopupPacks = () => axiosInstance.get(BILLING_TOPUP_PACKS);

export const getBillingBalance = () => axiosInstance.get(BILLING_BALANCE);

export const getBillingTransactions = ({ page = 1, pageSize = 20 } = {}) =>
  axiosInstance.get(BILLING_TRANSACTIONS, { params: { page, pageSize } });

export const createTopupOrder = (topupPackCode) =>
  axiosInstance.post(BILLING_TOPUP_CREATE_ORDER, { topupPackCode });

export const verifyTopupPayment = (paymentResponse) =>
  axiosInstance.post(BILLING_TOPUP_VERIFY, paymentResponse);

export const subscribeToPlan = (planCode) =>
  axiosInstance.post(BILLING_SUBSCRIBE, { planCode });

export const verifySubscriptionPayment = (paymentResponse) =>
  axiosInstance.post(BILLING_SUBSCRIPTION_VERIFY, paymentResponse);

export const cancelSubscription = ({ cancelAtPeriodEnd = true } = {}) =>
  axiosInstance.post(BILLING_CANCEL_SUBSCRIPTION, { cancelAtPeriodEnd });

export const claimTrial = () => axiosInstance.post(BILLING_CLAIM_TRIAL);
